import React, { useState } from 'react'
import { Carousel } from 'react-bootstrap'
import slider1 from "./../../images/slider1.png"
import slider2 from "./../../images/slider2.png"
import slider3 from "./../../images/slider3.png"
import { Link } from 'react-router-dom'

const Slider = () => {
    return (
        <Link to="/shopproduct">
            <Carousel>
                <Carousel.Item interval={2000}>
                    <div className="d-flex flex-row justify-content-center align-items-center">
                        <img
                            className="w-100"
                            src={slider1}
                            alt="First slide"
                        />
                    </div>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                    <div className="d-flex flex-row justify-content-center align-items-center">
                        <img
                            className="w-100"
                            src={slider2}
                            alt="First slide"
                        />
                    </div>
                </Carousel.Item>

                <Carousel.Item interval={2000}>
                    <div className="d-flex flex-row justify-content-center align-items-center">
                        <img
                            className="w-100"
                            src={slider3}
                            alt="First slide"
                        />
                    </div>
                </Carousel.Item>
            </Carousel>
        </Link>
    )
}

export default Slider
